import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import FAQRow from 'Components/Rows/FAQRow';
import FAQ from './FAQ';
import ContactUs from './ContactUs';
import ContactUsV2 from './ContactUsV2';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

const FrequentlyAskedQuestions = ({ match,  helmet, userAgent }) => {

  const { helpType, faqType } = match.params;
  const [activeProvider, setActiveProvider] = useState('BOS');

  useEffect(() => {
    const getActiveProvider = async () => {
      const res = await axios.get(API_GATEWAY + '/cms/textConfig/keyValue/key/contact_us_provider');
      setActiveProvider(res.data.value);
    };

    getActiveProvider();
  }, []);
  // TODO: After completing the transition successfully, this selection logic will be removed.
  const activeContactUsPage = activeProvider === 'BOS' ? <ContactUsV2 /> : <ContactUs />;

  switch (helpType) {
    case 'yardim-konulari':
      return <FAQ faqType={ faqType } userAgent={ userAgent } helpType={ helpType }/>;
    case 'bize-yazin':
      return activeContactUsPage;
  }

  return (
    <>
      <HeaderSimplePage color="green" title="Yardım" userAgent={ userAgent } helmet={ helmet } showSideMenu />
      <div className="page page--faq">
        <div className="faq-container">
          <FAQRow subject="Yardım Konuları" path="/yardim/yardim-konulari" />
          <FAQRow subject="Bize Yazın" path="/yardim/bize-yazin" />
        </div>
      </div>
    </>
  );
};

FrequentlyAskedQuestions.propTypes = {
  match: PropTypes.object,
  userAgent: PropTypes.object,
  helmet: PropTypes.object,
  pageConfig: PropTypes.object
};

export default withRouter(FrequentlyAskedQuestions);
